import type { SortEnum } from "@arbeidsark/shared"
import type React from "react"
import styled from "styled-components"

const Layout = styled.span`
  box-sizing: border-box;
  display: span;
  margin-left: 10px;
`

interface TableHeaderCellSortIconProps {
  sortStatus?: SortEnum
}

const StyledIcon = styled.i<TableHeaderCellSortIconProps>`
  font-size: 13px;

  color: ${(props) =>
    props.sortStatus ? props.theme.colors.primary : props.theme.colors.gray80};
`

export const TableHeaderCellSortIcon: React.CFC<
  TableHeaderCellSortIconProps
> = ({ sortStatus }) => {
  const icon = getIcon(sortStatus)

  return (
    <Layout>
      <StyledIcon className={icon} sortStatus={sortStatus} />
    </Layout>
  )
}

function getIcon(sortStatus?: SortEnum) {
  switch (sortStatus) {
    case "asc":
      return "fa fa-arrow-down"
    case "desc":
      return "fa fa-arrow-up"
    default:
      return "fa fa-sort-alt"
  }
}
